import { render } from "./SearchForm.vue?vue&type=template&id=316d9fab"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=316d9fab&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__